<template>
  <div class="app" :style="style">
    <!-- 加载动画，根据 closeLoading 状态显示 -->
    <div v-if="!closeLoading" class="container">
      <div class="loading">
        <div class="loading-point" />
      </div>
    </div>
    <!-- 路由视图 -->
    <router-view />
  </div>
</template>

<script>
import './style/index.scss'
import './utils/flexible.js'
import { renderBg } from './utils/tools'
import init from './init.js'
export default {
  name: 'App',
  data() {
    return {
      initFlag: false,
      globalConfig: { editing: false, unit: 'rem' },
      actionPageBg: {}
    }
  },
  provide() {
    return { globalConfig: this.globalConfig }
  },
  computed: {
    // 计算应用的样式
    style() {
      const styleOptions = this.$root.DATA?.options?.style || {}
      const { rect = { width: 375 }, background = {}} = styleOptions
      return {
        width: `${rect.width}${this.globalConfig.unit}`,
        height: rect.height ? `${rect.height}${this.globalConfig.unit}` : '',
        ...renderBg(background, this.$root.isSuWebp),
        ...this.actionPageBg
      }
    },
    // 获取关闭加载动画的状态
    closeLoading() {
      return this.$root.closeLoading
    }
  },
  beforeCreate() {
    init(this)
  },
  created() {
    // 监听 setPagebg 事件，更新页面背景样式
    this.$bus.$on('setPagebg', (bg) => {
      this.updatePageBackground(bg)
    })
  },
  mounted() {
    const autoCloseLoading = this.$root.DATA?.options?.basic?.autoCloseLoading
    // 根据配置自动关闭加载动画
    if (autoCloseLoading !== false) {
      this.$root.closeLoading = true
    }
    // 监听 setProductBg 事件，更新产品背景样式
    // this.$bus.$on('setProductBg', (bg) => {
    //   this.updateProductBackground(bg)
    // })
  },
  methods: {
    // 更新页面背景样式的方法
    updatePageBackground(bg) {
      const styleOptions = this.$root.DATA?.options?.style || {}
      // bg参数：{color,repeat,size,position,origin,imageType,image}
      const background = { ...styleOptions.background, ...bg }
      this.actionPageBg = {
        ...renderBg(background, this.$root.isSuWebp)
      }
    }
    // 更新产品背景样式的方法
    // updateProductBackground({ color, image }) {
    //   const styleOptions = this.$root.DATA?.options?.style || {}
    //   styleOptions.background = { ...styleOptions.background, image, color, imageType: 'image' }
    // }
  }
}
</script>

<style lang="scss">
html,
body {
  box-sizing: content-box;
}

.app {
  background-color: #ffffff;
  margin: 0 auto;
  position: relative;
}

.container {
  width: 100vw;
  overflow-x: hidden;
  position: relative;
  font-size: 12px;
  min-height: 100vh;
}

.loading {
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999999999;
}

.apiloading {
  background: rgba(255, 255, 255, 0.4);
  z-index: 99999;
}

@mixin point-style {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: rgba(255, 173, 60, 1);
  animation: loading-point 0.6s infinite ease-in-out;
}

.loading-point {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  @include point-style;
  transform: translateX(-19px);

  &::after {
    content: " ";
    @include point-style;
    position: absolute;
    right: -19px;
    top: 0;
    animation-delay: 0.2s;
  }

  &::before {
    content: " ";
    @include point-style;
    position: absolute;
    right: -38px;
    top: 0;
    animation-delay: 0.4s;
  }
}

@keyframes loading-point {
  0% {
    background-color: rgba(255, 173, 60, 1);
  }
  100% {
    background-color: rgba(255, 173, 60, 0.3);
  }
}
</style>
